<template>
  <div class="smart-voice-content">
    <div v-show="!teachDialogVisible">
      <div class="header">
        <div class="title">仿真配音</div>
        <div class="close icon-popup-close" @click="closeDialog"></div>
      </div>
      <div class="course">
        <div @click="showTeachDialog()">
          <iconfont
            name="#iconbofanganniu"
            font-size="18px"
            style="margin-right: 8px"
          ></iconfont>
          查看使用视频
        </div>
      </div>
      <div class="content">
        <div class="control-wrapper">
          <div class="control">
            <!-- <div class="msg">
              由于服务维护升级，新上线的音色暂时无法使用，您可以更换音色使用，我们将会尽快修复，敬请谅解。
            </div> -->
            <!-- <div class="msg" v-if="expiringSoonRoles.length"> -->
            <div class="msg" v-if="selectedSpeaker && selectedSpeaker.isCome && selectedSpeaker.reason">
              <!-- {{expiringSoonRoles.length}}款音色即将于2023.05.26下架（见右侧音色列表）。下架后，已生成音频不受影响，但将无法新增和修改。 -->
              <!-- 因部分音色优化，计划于5月26日下架（列表已标记）。为了不影响后期复用，建议非必要不使用。此外，平台正筹备上新更多优质音色，敬请期待~ -->
              {{ selectedSpeaker && selectedSpeaker.reason }}
            </div>
            <div class="msg enterprise-role" v-if="isTipShown">
              您正在使用 <span class="strong">企业专属音色</span>，需要升级为企业会员才可添加到视频。
            </div>
            <div class="intro">
              选择声音角色，输入文案，点击“确定”则提交文本。（单句文本不超过350字）
            </div>
            <div class="voice-wrapper overflow" ref="voiceListWrapper">
              <voiceDisplayer
                v-for="(item, i) in voiceList"
                :key="i"
                :readerOpts="readerOpts"
                :reader="reader"
                :readerId="readerId"
                :item="item"
                @testPlayEnded="testPlayEnded"
                @edit="editVoiceInDisplayer"
                @toggleEditing="isShowActiveReader"
                ref="voiceDisplayer"
              ></voiceDisplayer>
              <div ref="veWrapper">
                <voiceEditor
                  v-if="reader && voiceEditorVisible"
                  :visible="voiceEditorVisible"
                  :readerOpts="readerOpts"
                  :reader="reader"
                  :readerId="readerId"
                  :style="{ position: '' }"
                  :isShowCancel="voiceList && voiceList.length"
                  @cancel="voiceEditorVisible = false"
                  ref="voiceEditor"
                ></voiceEditor>
              </div>
              <div
                class="add-voice"
                v-if="false"
                v-show="!voiceEditorVisible"
                @click="addVoice"
              >
                <i
                  class="iconfont icontianjia"
                  style="font-size: 24px; margin-right: 10px"
                ></i>
                <span>再加一句</span>
              </div>
            </div>
          </div>
          <div class="control-bar">
            <template v-if="voiceList && voiceList.length">
              <div class="add-one" @click="addVoice">
                <div
                  class="content"
                  :class="{ 'is-disabled': isSomeEditing() }"
                >
                  <i
                    class="iconfont icontianjia"
                    style="font-size: 18px; margin-right: 10px; color: #5778fb"
                  ></i>
                  <span>再加一句</span>
                </div>
              </div>
              <div class="div"></div>
            </template>
            <div class="test-play-all" @click="testPlayAll()">
              <div
                class="content"
                :class="{ 'is-disabled': voiceList && !voiceList.length }"
              >
                <svg
                  viewBox="0 0 1024 1024"
                  width="18"
                  height="18"
                  style="margin-right: 10px"
                >
                  <use
                    :href="
                      duringTestPlayAll ? '#icon-test-pause' : '#icon-test-play'
                    "
                  ></use>
                </svg>
                试听全部
              </div>
            </div>
          </div>
        </div>

        <div class="roles">
          <div class="roles-title">请选择角色</div>
          <div class="role-tabs">
            <readerTab
              :text="'全部'"
              :activeLable="activeReaderTab"
              @onClick="clickReaderTab"
            ></readerTab>
            <readerTab
              v-for="(item, i) in readerTabs"
              :key="i"
              :text="item.name"
              :activeLable="activeReaderTab"
              :item="item"
              @onClick="clickReaderTab"
            ></readerTab>
          </div>
          <div class="role-filter-row">
            <roleFilter :initialValue="activeReaderFilter" @selectOption="onRoleFilterOptionSelected"></roleFilter>
          </div>
          <div class="role-content" :data-val="activeReaderShowed">
            <role
              v-for="item, i in readerOpts"
              :key="i"
              :label="item.label"
              :value="item.value"
              :active="activeReaderShowed && item.id === readerId"
              :item="item"
              :activeTab="activeReaderTab"
              :activeFilter="activeReaderFilter"
              @clickReader="onClickReader"
              ref="roles"
            ></role>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="row">
          <div class="btn btn-vip" v-if="!UserMsg.kdxfRemain || isTipShown" @click="addToWorks">
            添加到视频
            <div class="badge">VIP</div>
          </div>
          <div
            v-else
            class="btn"
            :class="{ 'is-disabled': voiceList && !voiceList.length }"
            @click="addToWorks"
          >
            添加到视频
          </div>
          <div class="menu" @click="isSaveToUser = !isSaveToUser">
            <div class="checkbox">
              <i class="iconfont icon39121_1" v-if="isSaveToUser"></i>
              <i class="iconfont icon3912" v-else></i>
            </div>
            <div class="text">保存至音频库</div>
          </div>
        </div>
        <div class="row" v-if="rightsMsg">
          <div
            class="rights-msg"
            :class="{ 'is-disabled': voiceList && !voiceList.length }"
          >
            {{ rightsMsg }}
          </div>
        </div>
      </div>

      <div
        class="progress __smart-voice"
        ref="progressRef"
        v-show="false"
        style="
          position: fixed;
          top: 50%;
          left: 50%;
          width: 126px;
          height: 126px;
          transform: translate(-50%, -50%);
        "
      >
        <div class="lds-default">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="progress__text">正在合成语音</div>
      </div>
    </div>
    <div v-show="teachDialogVisible" class="teachBox">
      <div
        @click="showTeachDialog"
        class="closeTeachDialog icon-popup-close"
      ></div>
      <div class="title">{{ teachDialogTitle }}</div>
      <video
        ref="teachVideo"
        class="teachBody"
        src="https://resources.laihua.com/2021-6-7/63aec779-f36b-4504-942b-38001bb7aaaf.mp4"
        controls
      ></video>
    </div>
    <div v-show="showAIRuleTip" class="smart-voice-rule">
      <div>
        <p>AI配音次数扣除说明</p>
        <div class="rule-list">
          <span>1. 输入文本，生成和试听配音，不消耗配音次数。</span>
          <span>2. 再编辑配音文本，不消耗配音次数。</span>
          <span>3. 将配音添加至视频，<b>将消耗1次配音次数。</b></span>
        </div>
        <div class="remain-num" v-show="UserMsg.kdxfRemain <= 500">
          您的剩余配音次数: <b>{{ UserMsg.kdxfRemain }}</b>
        </div>
        <div class="btn" @click="closeRule">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import role from "./reader";
import readerTab from "./readerTab";
import voiceDisplayer from "./voiceDisplayer";
import voiceEditor from "./voiceEditor";
import roleFilter from './roleFilter.vue';
export default {
  components: {
    role,
    readerTab,
    voiceDisplayer,
    voiceEditor,
    roleFilter,
    iconfont: () => import("@/platformCode/iconfont"),
  },
  data() {
    return {
      teachDialogVisible: false,
      teachDialogTitle: "快速掌握 AI多角色配音对话功能",
      readerOpts: [
        {
          label: "",
          value: "",
        },
      ],
      readerObj: {},
      reader: "",
      readerId: void 0,
      readerTabs: [],
      activeReaderTab: "",
      activeReaderFilter: 'all',
      testPlayAllData: {
        index: 0,
      },
      voiceEditorVisible: false,
      isSaveToUser: true,
      rightsMsg: "",
      activeReaderShowed: false,
      showAIRuleTip: false,
      isShowRuleTip: true,
      duringTestPlayAll: false,
      speakerExpireMsgVisible: true,
      isTipShown: false
    };
  },
  computed: {
    ...mapGetters([
      "Window_Size",
      "TOOL",
      "PreviewType",
      "SoundRecord",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
      "IsDoingSmartVoice",
      "AIReader",
      "isPersonVip",
      'UserLevelInfo',
      'IsOldUser'
    ]),
    ...mapGetters({
      voiceList: "smartVoice/list",
      receiveData: "addSoundtrack/getReceiveData",
      dubbingArr: "addSoundtrack/getDubbingArr",
    }),
    expiringSoonRoles () {
      return this.readerOpts.filter(v => v.isCome);
    },
    selectedSpeaker () {
      return this.readerOpts.find(v => this.readerId === v.id);
    },
    advancedSpeakerPowers () {
      const voiceList = this.voiceList;
      const found = voiceList.some(v => v.queryParams.payType === 1);
      const found2 = voiceList.some(v => v.queryParams.payType === 2);
      const arr = [];
      if (found) {
        arr.push(1);
      }
      if (found2) {
        arr.push(2);
      }
      return arr;
    },
    isEnterpriseRoleInVoiceList () {
      return this.advancedSpeakerPowers.includes(1);

      // return this.voiceList.some(v => {
      //   return (this.readerOpts.filter(item => item.aiType) || []).some(x => {
      //     const speakerId = v.queryParams && v.queryParams.speakerId;
      //     if (speakerId) {
      //       return x.id === speakerId;
      //     }
      //     return v.queryParams && x.sourceId === v.queryParams.speaker
      //   })
      // });
    },
    isEnterpriseSRoleInVoiceList () {
      return this.advancedSpeakerPowers.includes(2);
    },
    isEnterpriseRoleEditing () {
      return this.voiceEditorVisible
        && this.reader
        && (this.readerOpts.filter(item => item.aiType) || []).some(v => this.readerId ? v.id === this.readerId : v.sourceId === this.reader);
    }
  },
  watch: {
    "voiceList.length"(val, old) {
      this.updateTipShown();
      if (val > old) {
        this.toggleVoiceEditor(false);
      }
      if (!val) {
        this.toggleVoiceEditor(true);
      }
    },
    voiceEditorVisible(val) {
      this.activeReaderShowed = this.isSomeEditing();
    },
  },
  created() {
    this.$bus.on("smartVoice.generating", this.onGenerating);
    this.getReaders();
    this.getSmartVoiceInfo();
    if (!this.voiceList.length) {
      this.toggleVoiceEditor(true);
    }
    if (window.localStorage.getItem("hasShowRuleTip")) {
      this.isShowRuleTip = false;
    }
    // this.checkExpireMsg();
    // this.tid = setInterval(() => {
    //   this.checkExpireMsg();
    // }, 1000 * 60);
  },
  mounted () {
    this.updateTipShown();
  },
  beforeDestroy() {
    this.$bus.off("smartVoice.generating", this.onGenerating);
    clearInterval(this.tid);
  },
  methods: {
    showTeachDialog() {
      this.teachDialogVisible = !this.teachDialogVisible;
      let el = this.$refs.teachVideo;
      if (this.teachDialogVisible) {
        el.currentTime = 0;
        el.play();
      } else {
        el.pause();
      }
    },
    isShowActiveReader() {
      this.activeReaderShowed = this.isSomeEditing();
    },
    isSomeEditing() {
      return (
        this.voiceEditorVisible ||
        (this.$refs.voiceDisplayer &&
          this.$refs.voiceDisplayer.some((v) => v.editing))
      );
    },
    onGenerating(val) {
      if (val) {
        let ref = this.$refs.progressRef;
        if (ref) {
          let mask = document.body.querySelector(".gene_recoring");
          ref.style.zIndex = mask.style.zIndex - 0 + 10;
          let clone = ref.cloneNode(true);
          clone.style.display = "";
          document.body.appendChild(clone);
        }
      } else {
        $("body > .progress.__smart-voice").remove();
      }
    },
    closeDialog() {
      let text =
        this.$refs.voiceEditor && this.$refs.voiceEditor.textarea.value;
      if (text) {
        this.confirmClose();
        return;
      }
      let hasText =
        this.$refs.voiceDisplayer &&
        this.$refs.voiceDisplayer.some((v) => {
          return (
            v.editing &&
            v.$refs.voiceEditor &&
            v.$refs.voiceEditor.textarea.value
          );
        });
      if (hasText) {
        this.confirmClose();
        return;
      }

      this.doClose();
    },
    doClose() {
      this.$store.commit("smartVoice/setSmartVoiceDialogVisible", false);
    },
    confirmClose() {
      this.$modal.show("SubtitleMessageDialog", {
        view: "CloseSmartVoiceDialog",
        resultCallback: (value) => {
          if (value && value.type == "Ok") {
            this.doClose();
          }
        },
      });
    },
    getReaders() {
      // this.$http.get('/api/user/kdxfaudio/source')
      this.$http
        .get("/api/user/audioAI/source")
        .then((res) => {
          let { data } = res.data;
          this.readerOpts = data.map((read) => {
            return {
              ...read,
              value: read.sourceId,
              label: read.sourceName,
            };
          });
          this.reader = this.readerOpts[0].value;
          this.readerId = this.readerOpts[0].id;
          // if (this.AIReader) {
          //   this.reader = this.AIReader;
          //   this.$store.commit("set_Reader", "");
          // } else {
          //   this.reader = this.readerOpts[0].value;
          // }
          this.getReaderTabs();
          this.$bus.emit("smartVoice.getReadersDone");
          this.$nextTick(() => {
            if (
              this.$refs &&
              this.$refs.voiceDisplayer &&
              this.$refs.voiceDisplayer.length
            ) {
              this.$refs.voiceDisplayer.forEach((v) => {
                v.getReader();
              });
            }
          });
        })
        .catch(this.err);
    },
    getReaderTabs() {
      let cates =
        this.readerOpts.reduce((memo, { category } = {}) => {
          if (!category) {
            return memo;
          }
          let arr = [category];
          if (category.indexOf(",") > -1) {
            arr = category.split(",");
          }
          arr.forEach((v) => {
            if (memo.indexOf(v) < 0) {
              memo.push(v);
            }
          });
          return memo;
        }, []) || [];
      //0: 男声  1：女声 2：童声 3:英文
      let names = ["男声", "女声", "童声", "英文", "中英混合"];
      cates = cates
        .sort((a, b) => a - b)
        .map((v) => {
          return {
            value: v,
            name: names[v],
          };
        });
      this.readerTabs = cates;
    },
    clickReaderTab(tab) {
      this.activeReaderTab = tab.value || "";
    },
    onClickReader(val) {
      this.reader = val.value;
      this.readerId = val.id;
    },
    testPlayAll(index = 0) {
      if (!this.voiceList.length) {
        return;
      }
      if (!index) {
        this.testPlayAllData.index = 0;
      }
      if (this.duringTestPlayAll) {
        (this.$refs.voiceDisplayer || []).forEach((v) => {
          v.$refs && v.$refs.audio && v.$refs.audio.pause();
        });
        this.duringTestPlayAll = false;
        return;
      }
      this.duringTestPlayAll = true;
      this.$refs.voiceDisplayer[index].testPlay();
    },
    testPlayEnded() {
      if (this.duringTestPlayAll) {
        this.testPlayAllData.index += 1;
        let index = this.testPlayAllData.index;
        if (index < this.$refs.voiceDisplayer.length) {
          setTimeout(() => {
            this.$refs.voiceDisplayer[index || 0].testPlay();
          }, 500);
        }
      }
    },
    toggleVoiceEditor(flag) {
      if (flag) {
        this.$bus.emit("smartVoice.showVoiceEditor");
      }
      this.voiceEditorVisible = flag;
    },
    editVoiceInDisplayer(item) {
      this.reader = item.queryParams.speaker;
      this.readerId = item.queryParams.speakerId;
      this.toggleVoiceEditor(false);
      // this.$refs.roles.forEach(v => v.$forceUpdate());
    },
    addVoice() {
      let isSomeEditing = this.isSomeEditing();
      if (isSomeEditing) {
        return;
      }
      let len = this.voiceList.length;
      let voice = this.voiceList[len - 1];
      if (voice) {
        let reader = voice.queryParams.speaker;
        let readerId = voice.queryParams.speakerId;
        let readerData = this.readerOpts.find((v) => readerId ? v.id === readerId : v.value === reader);
        if (readerData) {
          this.reader = reader;
          this.readerId = readerId;
        }
      }
      this.toggleVoiceEditor(true);
      this.$nextTick(() => {
        let sh = this.$refs.voiceListWrapper.scrollHeight;
        let oh = this.$refs.voiceListWrapper.offsetHeight;
        this.$refs.voiceListWrapper.scrollTop = sh - oh;
      });
    },
    getReaderData(val) {
      return this.readerOpts.find((item) => val.speakerId ? item.id === val.speakerId : item.value === val.speaker) || {};
    },
    saveToUser() {
      this.voiceList.forEach((item) => {
        this.saveRecordToUser(item);
      });
    },
    saveRecordToUser(item) {
      let { label = "no-reader" } = this.getReaderData(
        item.queryParams
      );
      this.$http
        .post("/api/user/music", {
          url: item.filename,
          title: item.queryParams.text.slice(0, 5) + "-" + label,
          duration: item.duration,
          musicType: 2,
          fileType: 50,
        })
        .then(({ data: resData }) => {
          let { data, code, msg } = resData;
          if (code !== 200) {
            this.$message({
              message: msg,
              type: "error",
            });
            return;
          }

          // 通知右侧栏
          // this.$bus.emit("collectPersonal_vue", { data: "collectMusicType" });

          // let rec = {
          //   // endTime: duration * 1000,
          //   fileType: data.fileType,
          //   id: data.id,
          //   resourceId: data.id,
          //   startTime: 0,
          //   title: data.title,
          //   url: this.$handleAssetsUrl(data.url)
          // };

          // if (this.PreviewType === "global") {
          //   this.$bus.emit("addAudioToGlobal", rec);
          // } else {
          //   this.$bus.emit("addAudioToScene", rec);
          // }
        })
        .catch((err) => {});
    },
    async addToWorks() {
      let popupShowed = this.checkVip();
      if (popupShowed) {
        return;
      }

      if (this.UserLevelInfo.levelName !== 'enterprise') {
        // 第一次出现规则弹窗
        if (this.isShowRuleTip) {
          this.showAIRuleTip = true;
          this.isShowRuleTip = false;
          return;
        }
      }

      let { start, end } = this.receiveData;
      if (end - start < 0.2) {
        this.$message({
          message: "添加失败，当前位置已有声音",
          type: "error",
        });
        return;
      }

      if (this.voiceList && !this.voiceList.length) {
        return;
      }

      if (this.isSaveToUser) {
        this.saveToUser();
      }

      let addedSize = this.voiceList.length;
      let isReplace = this.receiveData.operation === "replace";
      if (isReplace) {
        this.replaceToWorks();
      } else {
        let isStopLoop = false;
        this.voiceList.forEach((item, i) => {
          if (isStopLoop) {
            return;
          }
          let currEnd = start + item.duration;
          if (currEnd >= end) {
            currEnd = end;
            isStopLoop = true;
            addedSize = i + 1;
          }
          let timeSlot = [start, currEnd];
          let { label = "no-reader" } = this.getReaderData(
            item.queryParams
          );
          // let svid = uuid.generate();
          let dubbing = {
            // resourceId: 'sv-' + svid,
            // svid,
            // resourceId: item.id,
            // id: item.id,
            isSmart: 1,
            title: item.queryParams.text.slice(0, 5) + "-" + label,
            type: "1",
            fileType: 50,
            url: this.$unhandleAssetsUrl(item.filename),
            cut: [0, item.duration],
            timeSlot,
          };
          let index = this.receiveData.index + i;
          this.$store.commit("addSoundtrack/addDubbing", {
            dubbing,
            index,
          });
          this.$store.commit("addSoundtrack/setDubbingIndex", index);
          this.$bus.emit("insert_subtitle_undo", {
            type: "addDubbing",
            data: {
              index,
              data: JSON.stringify(dubbing),
            },
          });

          start += item.duration + 0.5;
        });
      }

      sensors.track("addAiDubbing", {
        voice_number: addedSize || 0,
        is_save: !!this.isSaveToUser,
      });

      let worksList = this.$store.getters["smartVoice/worksList"];
      let list = this.$store.getters["smartVoice/list"];
      list = list.map((v) => {
        return {
          pause_points: v.queryParams.pause_points,
          provider: v.queryParams.provider,
          speaker: v.queryParams.speaker,
          speakerId: v.queryParams.speakerId,
          speed: +v.queryParams.speed,
          text: v.textarea,
          url: this.$unhandleAssetsUrl(v.filename),
        };
      });
      worksList = [...worksList, ...list];
      this.$store.commit("smartVoice/setWorksList", worksList);

      this.$store.commit("smartVoice/setList", []);

      await this.$http.post("/api/user/audioAI/use", {
        kdxf: 1,
      });
      this.$bus.emit("upDataUserMsg_vue");
      this.$store.commit("smartVoice/setSmartVoiceDialogVisible", false);
      if (isReplace) {
        this.$store.commit(
          "addSoundtrack/setDubbingIndex",
          this.receiveData.index
        );
      }
    },
    replaceToWorks() {
      let index = this.receiveData.index;
      let ni = [this.receiveData.index + 1];
      let nextDub = this.dubbingArr[ni];
      let end = this.TOOL.getDuration() / 1000;
      if (nextDub) {
        end = nextDub.timeSlot[0];
      }
      let start = this.receiveData.start;
      let dubbings = [];
      let dubEnd = 0;
      let dubStart = start;
      this.voiceList.some((item, i) => {
        let isOver = false;
        dubEnd = dubStart + item.duration;
        if (dubEnd > end) {
          dubEnd = end;
          isOver = true;
        }
        let timeSlot = [dubStart, dubEnd];
        let { label = "no-reader" } = this.getReaderData(
          item.queryParams
        );
        let dub = {
          title: item.queryParams.text.slice(0, 5) + "-" + label,
          type: "1",
          fileType: 50,
          url: this.$unhandleAssetsUrl(item.filename),
          cut: [0, item.duration],
          timeSlot,
        };
        dubbings.push(dub);
        dubStart = dubStart + item.duration + 0.5;

        return isOver;
      });

      let reData = {};
      let select = this.$store.getters["addSoundtrack/getSelectDubbing"];
      for (let key in select) {
        reData[key] = select[key];
      }
      reData = [reData];
      reData = JSON.stringify(reData);

      this.$store.commit("addSoundtrack/addDubbingGroup", {
        dubbings,
        index: this.receiveData.index,
        delNum: 1,
      });
      this.$bus.emit("replace_current_dubing", {
        event: "replace",
      });
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateDubbingGroup",
        data: {
          index: index,
          data: JSON.stringify(dubbings),
          reData: reData,
        },
      });
    },
    getSmartVoiceInfo() {
      let { kdxfRemain, kdxfTimes } = this.UserMsg;
      let temp = "";
      if (kdxfTimes > 999) {
        temp = "";
      } else {
        temp = `剩余AI配音次数：${kdxfRemain}`;
      }
      // if (this.UserLevelType >= 2 || this.UserLevelInfo.levelName === 'basic') {
      if (this.UserLevelType >= 2 || this.UserLevelInfo.levelName === 'basic') {
        temp = "";
      }
      if (kdxfRemain > 5000) {
        temp = "";
      }
      this.rightsMsg = temp;
    },
    checkVip() {
      let popupShowed;
      let { kdxfRemain, kdxfTimes } = this.UserMsg;
      // const isPoor = this.UserLevelInfo.levelName === 'basic';
      if (!kdxfRemain) {
        this.$memberGuide({
          show: true,
          context: this,
          isSubtitle: true,
          funcRight: {
            type: "AIDubbing",
            name: "AI配音",
          },
        });
        // this.$bus.emit("backtoCanvas");
        popupShowed = true;
        return popupShowed;
      }
      // if (!this.UserMsg.aiType && this.isEnterpriseRoleInVoiceList) {
      //   this.$memberGuide({
      //     show: true,
      //     isSubtitle: true,
      //     funcRight: {
      //       type: "enterpriseSpeaker",
      //       name: "企业专属音色",
      //     },
      //   });
      //   popupShowed = true;
      //   return popupShowed;
      // }

      popupShowed = this.getTipShown({
        onPopupShow: (key) => {
          if (key === enterpriseSpeaker) {
            this.showBuy();
          } else {
            this.showBuy(key);
          }
        }
      }).shown;

      return popupShowed;
    },
    showBuy (link) {
      this.$memberGuide({
        show: true,
        context: this,
        isSubtitle: true,
        funcRight: {
          type: "enterpriseSpeaker",
          name: "企业专属音色",
        },
        link: link
      });
    },
    getTipShown ({onPopupShow = () => void 0} = {}) {
      let shown = false;
      const payTypeOfCanUse = this.UserMsg.aiType;
      const {isEnterpriseRoleInVoiceList, isEnterpriseSRoleInVoiceList} = this;
      const levelCode = this.UserLevelInfo.levelCode;

      if (this.IsOldUser) {
        if (isEnterpriseRoleInVoiceList) {
          if ([0, 2].includes(payTypeOfCanUse) && levelCode < 2) {
            onPopupShow('enterpriseSpeaker');
            shown = true;
            return { shown };
          }
        } else if (isEnterpriseSRoleInVoiceList) {
          if ([0].includes(payTypeOfCanUse)) {
            onPopupShow('enterpriseSpeaker');
            shown = true;
            return { shown };
          }
        }
      } else {
        if (isEnterpriseSRoleInVoiceList) {
          if ([0, 1].includes(payTypeOfCanUse)) {
            onPopupShow('buyUpEnterpriseVip');
            shown = true;
            return { shown };
          }
        } else if (isEnterpriseRoleInVoiceList) {
          if ([0].includes(payTypeOfCanUse)) {
            onPopupShow('buyEnterpriseVip');
            shown = true;
            return { shown };
          }
        }
      }
      return {
        shown
      }
    },
    updateTipShown () {
      this.isTipShown = this.getTipShown().shown || false;
    },
    closeRule() {
      this.showAIRuleTip = false;
      window.localStorage.setItem("hasShowRuleTip", true);
    },
    checkExpireMsg () {
      this.speakerExpireMsgVisible = true;
      const expireTime = new Date('2022-07-27 10:00:00+0800');
      if (Date.now() - expireTime >= 0) {
        this.speakerExpireMsgVisible = false;
        clearInterval(this.tid);
      }
    },
    onRoleFilterOptionSelected (item) {
      this.activeReaderFilter = item.value;
    }
  },
};
</script>

<style lang="scss" scoped>
.smart-voice-content {
  color: #474261;
  position: relative;
  width: 100%;
  height: 100%;
}

// ----弹框
.smart-voice-content .teachBox {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  padding: 40px 84px 47px 84px;
  background-color: #ffffff;
  .closeTeachDialog {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
  .title {
    width: 100%;
    height: 24px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;

    line-height: 24px;
    color: #474261;
    text-align: center;
    margin-bottom: 20px;
  }
  .teachBody {
    width: 779px;
    height: 438px;
    background: #dadada;
    opacity: 1;
  }
}

.smart-voice-rule {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  color: #333333;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 393px;
    height: auto;
    padding: 30px 40px;
    background-color: #fff;
    border-radius: 4px;

    > p {
      font-size: 14px;
      line-height: 26px;
      font-weight: bold;
    }

    b {
      color: #ea3d45;
    }
  }

  .rule-list {
    display: flex;
    margin-top: 24px;
    width: 100%;
    flex-direction: column;
    text-align: left;

    > span {
      line-height: 22px;
    }
  }

  .remain-num {
    margin-top: 24px;
    width: 100%;
    text-align: left;
  }

  .btn {
    margin-top: 40px;
    width: 120px;
    height: 34px;
    line-height: 34px;
    font-size: 14px;
    color: #fff;
    background: rgba(87, 120, 251, 1);
    opacity: 1;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: rgba(87, 120, 251, 0.39);
    }
  }
}

.teachBox {
  width: 779px;
  height: 438px;
  background: #dadada;
  opacity: 1;
}
.header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 40px;
  & .title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
  & .close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
}
.course {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 42px;
  padding-right: 42px;
  margin-bottom: 5px;

  &:hover {
    & svg {
      opacity: 0.8;
    }
  }
  &>div {
    width: 115px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.content {
  display: flex;
  padding-left: 42px;
  padding-right: 42px;
  & .control {
    width: 600px;
    height: 360px;
    background: rgba(#d9ddea, 0.2);
  }
}
.control-wrapper {
  margin-right: 18px;
}
.control {
  position: relative;
  & > .msg {
    display: flex;
    align-items: center;
    // justify-content: center;
    width: 100%;
    min-height: 28px;
    font-size: 11px;
    // white-space: nowrap;
    color: #FA8C16;
    background: #FFF0E0;
    padding: 3px;
    padding-left: 6px;
    padding-right: 6px;
    text-align: left;
    &.enterprise-role {
      background: #E6EBFE;
      color: #474261;
      .strong {
        color: #113DF5;
        font-weight: bold;
      }
    }
  }
  display: flex;
  flex-direction: column;
  height: 360px;
  margin-bottom: 4px;

  & .intro {
    padding-left: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: 27px;
    padding-bottom: 24px;
    font-size: 14px;
    color: #474261;
  }
}
.control-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(#d9ddea, 0.2);
  border-radius: 4px;
  & .div {
    width: 1px;
    height: 38px;
    background: #d9ddea;
  }
  & .test-play-all,
  & .add-one {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
    cursor: pointer;
    & > .content {
      padding: 0;
      &.is-disabled {
        opacity: 0.2;
        cursor: not-allowed;
      }
    }
    &:hover {
      & .iconfont {
        opacity: 0.8;
      }
      & svg {
        opacity: 0.8;
      }
    }
  }
}
.is-disabled {
  opacity: 0.2;
  cursor: not-allowed;
}
.voice-wrapper {
  padding-left: 20px;
  overflow: auto;
  width: 100%;
  flex-grow: 1;
  & .add-voice {
    display: flex;
    align-items: center;
    width: 90px;
    cursor: pointer;
    & > span {
      display: flex;
      align-items: center;
      width: 56px;
      height: 19px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      line-height: 22px;
      color: #474261;
    }
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d8dee9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
}
.roles {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 244px;
  height: 413px;
  background: #f6f6fc;
}
.roles-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: #d9ddea;
  opacity: 1;
  border-radius: 4px 4px 0px 0px;
}
.role-tabs {
  width: 100%;
  height: 40px;
  display: flex;
  font-size: 12px;
}
.role-content {
  width: 100%;
  flex-grow: 1;
  height: 333px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d8dee9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 90px;
  & > .row {
    width: 100%;
    display: flex;
  }
  & .btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 345px;
    margin-right: 10px;
    width: 120px;
    height: 39px;
    background: #5778fb;
    opacity: 1;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #7d95f5;
    }
    &.is-disabled {
      opacity: 0.2;
      cursor: not-allowed;
    }
  }
  & .btn-vip {
    position: relative;
    background: linear-gradient(232deg, #E6A73A 0%, #F9CF82 100%);
    &>.badge {
      position: absolute;
      left: 95px;
      top: -6px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 16px;
      background: linear-gradient(126deg, #36332F 0%, #12100A 100%);
      border-radius: 8px;
      font-size: 12px;
      color: #F8DBB2;
    }
  }
  & .rights-msg {
    margin-top: 5px;
    color: #5778fb;
    white-space: nowrap;
    font-size: 12px;
    margin-left: 345px;
  }
  & .menu {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 39px;
  }
  & .checkbox {
    margin-right: 4px;
    & > .iconfont {
      font-size: 12px;
      color: #707070;
    }
  }
  & .text {
    color: #898d96;
  }
}
.role-filter-row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.progress {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__text {
    text-align: center;
  }
}

.lds-default {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 64px;
}
.lds-default div {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #5778fb;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}
.lds-default div:nth-child(1) {
  top: 29px;
  left: 53px;
  animation-delay: 0s;
}
.lds-default div:nth-child(2) {
  top: 18px;
  left: 50px;
  animation-delay: -0.1s;
}
.lds-default div:nth-child(3) {
  top: 9px;
  left: 41px;
  animation-delay: -0.2s;
}
.lds-default div:nth-child(4) {
  top: 6px;
  left: 29px;
  animation-delay: -0.3s;
}
.lds-default div:nth-child(5) {
  top: 9px;
  left: 18px;
  animation-delay: -0.4s;
}
.lds-default div:nth-child(6) {
  top: 18px;
  left: 9px;
  animation-delay: -0.5s;
}
.lds-default div:nth-child(7) {
  top: 29px;
  left: 6px;
  animation-delay: -0.6s;
}
.lds-default div:nth-child(8) {
  top: 41px;
  left: 9px;
  animation-delay: -0.7s;
}
.lds-default div:nth-child(9) {
  top: 50px;
  left: 18px;
  animation-delay: -0.8s;
}
.lds-default div:nth-child(10) {
  top: 53px;
  left: 29px;
  animation-delay: -0.9s;
}
.lds-default div:nth-child(11) {
  top: 50px;
  left: 41px;
  animation-delay: -1s;
}
.lds-default div:nth-child(12) {
  top: 41px;
  left: 50px;
  animation-delay: -1.1s;
}
@keyframes lds-default {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoice/smartVoiceContent.vue